import React, { useEffect, useState } from 'react';
import { Button } from '@fragments';
import { IconMinus, IconPlus } from '@tabler/icons-react';
import './styles.scss';

// A compact stepper (− value +) for toolbar numbers such as the font size. Typing commits
// on Enter or blur; the buttons step, and holding Shift steps ten times further.
export default function NumberField({ value, onChange, min, max, step = 1, label }) {
  const [draft, setDraft] = useState(String(value));
  useEffect(() => { setDraft(String(value)); }, [value]);
  const set = next => onChange(Math.min(max, Math.max(min, Math.round(next * 10) / 10)));
  const commitDraft = () => { const number = Number(draft.replace(',', '.')); if (Number.isFinite(number)) set(number); else setDraft(String(value)); };
  return <div className="art-number" role="group" aria-label={label}>
    <Button size="micro" variant="text" color="overlay" preventLoading icon={<IconMinus />} aria-label={`${label} −`} disabled={value <= min}
      onClick={event => set(value - step * (event.shiftKey ? 10 : 1))} />
    <input value={draft} inputMode="decimal" aria-label={label} onChange={event => setDraft(event.target.value)}
      onBlur={commitDraft} onKeyDown={event => {
        if (event.key === 'Enter') event.currentTarget.blur();
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') { event.preventDefault(); set(value + (event.key === 'ArrowUp' ? 1 : -1) * step * (event.shiftKey ? 10 : 1)); }
      }} />
    <Button size="micro" variant="text" color="overlay" preventLoading icon={<IconPlus />} aria-label={`${label} +`} disabled={value >= max}
      onClick={event => set(value + step * (event.shiftKey ? 10 : 1))} />
  </div>;
}
